import { Address } from '@models/address.model'
import { BaseModel } from '@models/generic.model'
import { Account } from '@models/account.model'

export class User extends BaseModel {
	username?: string
	name: string
	phone: string
	email: string
	status?: UserStatus
	birthdate?: string
	address?: Address
	account?: Account
	roles: UserRole[]
}

export enum UserRole {
	PCA_SUPER_ADMIN = 'pca_super_admin', PCA_MEMBER = 'pca_member', SUPPLIER = 'supplier'
}

export class UserSearch extends BaseModel {
}

export enum UserStatus {
	REMOVED = 'REMOVED',
	UNCONFIRMED = 'UNCONFIRMED',
	CONFIRMED = 'CONFIRMED',
	ARCHIVED = 'ARCHIVED',
	COMPROMISED = 'COMPROMISED',
	UNKNOWN = 'UNKNOWN',
	RESET_REQUIRED = 'RESET_REQUIRED',
	FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
	EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
}
